import { render, staticRenderFns } from "./Results.ItemAnalysis.ComparisonTable.vue?vue&type=template&id=2b4f63ae&scoped=true&"
import script from "./Results.ItemAnalysis.ComparisonTable.vue?vue&type=script&lang=js&"
export * from "./Results.ItemAnalysis.ComparisonTable.vue?vue&type=script&lang=js&"
import style0 from "./Results.ItemAnalysis.ComparisonTable.vue?vue&type=style&index=0&id=2b4f63ae&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b4f63ae",
  null
  
)

export default component.exports